import PropTypes from "prop-types";
import React, { useMemo } from "react";

import { DropDown } from "@swa-ui/core";
import { swaDate } from "@swa-ui/date";
import i18n from "@swa-ui/locale";

import { withFormField } from "../withFormField";

export const TimeFormField = (props) => {
  const {
    componentProps,
    defaultValue = "11:00am",
    endTime = "11:59pm",
    interval = 30,
    startTime = "12:00am",
    times,
  } = props;
  const timeFormat = i18n("TimeFormField__FORMAT");
  const FormField = useMemo(() => withFormField(DropDown, { useController: true }), []);
  const timeList = useMemo(() => times ?? getTimes(), [times]);

  return <FormField {...getDropDownProps()} />;

  function getDropDownProps() {
    return {
      ...props,
      componentProps: {
        defaultValue,
        list: timeList,
        ...componentProps,
      },
    };
  }

  function getTimes() {
    const processedStartTime = swaDate(startTime, timeFormat);
    const defaultTimes = [processedStartTime];
    const processedEndTime = swaDate(endTime, timeFormat);

    while (defaultTimes[defaultTimes.length - 1].isBefore(processedEndTime)) {
      let nextTime = defaultTimes[defaultTimes.length - 1].add(interval, "minutes");

      if (nextTime.isAfter(processedEndTime)) {
        nextTime = processedEndTime;
      }

      defaultTimes.push(nextTime);
    }

    return defaultTimes.map(formatTime);
  }

  function formatTime(date) {
    return date.format(timeFormat);
  }
};

TimeFormField.propTypes = {
  /**
   * Props to be passed along to child DropDown component.
   */
  componentProps: PropTypes.object,

  /** Optional time string (default: "11:00am") representing what is selected by default. */
  defaultValue: PropTypes.string,

  /** Optional time string (default: "11:59pm") for the start of the list of times to select. */
  endTime: PropTypes.string,

  /** Optional time interval, in minutes. */
  interval: PropTypes.number,

  /** Optional time string (default: "12:00am") for the end of the list of times to select. */
  startTime: PropTypes.string,

  /** Optional array of times to list as choices. */
  times: PropTypes.arrayOf(PropTypes.string),
};
